import React from 'react';

function NotFound({ currLang }) {
  return (
    <div>
      <h1>
        {currLang === "IS" ? "Úps, þessi síða er ekki til!" : "Whoops, this site does not exist!"}
      </h1>
      <h2>
        {currLang === "IS" ? "Vinsamlegast athugaðu hvort hlekkurinn hafi verið réttur." : "Please check if the link in the search bar is correct."}
      </h2>
      <h3>
        <a href="/">{currLang === "IS" ? "Fara aftur á forsíðuna" : "Go back to the homepage"}</a>
      </h3>
    </div>

  );
}

export default NotFound;
